import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import LoginContainer from "../containers/LoginContainer";
import Home from './Home';
import HelperServices from '../services/CommonServices';

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
    }
  }

  componentDidMount() {
    (async () => {
      try {
        const isValid = await HelperServices.getTokenValidityStatus();
        if (isValid) {
          this.props.authenticateUser(true);
        }
      } catch (error) {

      }
      this.setState({
        loading: false
      })
    })();
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="app-loader" />
      )
    }

    return (
      <Router>
        <Switch>
          <Route exact path="/login" component={LoginContainer} />
          <Route path="/" component={Home} />
        </Switch>
      </Router>
    );
  }
}

export default App;
